export const TURNSTILE_SITE_KEY = process.env.NODE_ENV === "production"
  ? process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY || ""
  : ""
